/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsGroupReference,
    ElementsGroupReferenceFromJSON,
    ElementsGroupReferenceFromJSONTyped,
    ElementsGroupReferenceToJSON,
    ElementsUserReference,
    ElementsUserReferenceFromJSON,
    ElementsUserReferenceFromJSONTyped,
    ElementsUserReferenceToJSON,
    ScheduleReference,
    ScheduleReferenceFromJSON,
    ScheduleReferenceFromJSONTyped,
    ScheduleReferenceToJSON,
    SubtaskReference,
    SubtaskReferenceFromJSON,
    SubtaskReferenceFromJSONTyped,
    SubtaskReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface JobPartialUpdate
 */
export interface JobPartialUpdate {
    /**
     * 
     * @type {Array<SubtaskReference>}
     * @memberof JobPartialUpdate
     */
    subtasks?: Array<SubtaskReference>;
    /**
     * 
     * @type {Array<ScheduleReference>}
     * @memberof JobPartialUpdate
     */
    schedules?: Array<ScheduleReference>;
    /**
     * 
     * @type {Array<ElementsUserReference>}
     * @memberof JobPartialUpdate
     */
    allowUsers?: Array<ElementsUserReference>;
    /**
     * 
     * @type {Array<ElementsGroupReference>}
     * @memberof JobPartialUpdate
     */
    allowGroups?: Array<ElementsGroupReference>;
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof JobPartialUpdate
     */
    variableDefinitions?: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobPartialUpdate
     */
    mediaRoots?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof JobPartialUpdate
     */
    specialType?: JobPartialUpdateSpecialTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JobPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof JobPartialUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobPartialUpdate
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobPartialUpdate
     */
    allowOthersToStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobPartialUpdate
     */
    allowClientToStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobPartialUpdate
     */
    showAsButton?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobPartialUpdate
     */
    inputType?: JobPartialUpdateInputTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobPartialUpdate
     */
    addToNewMediaRoots?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobPartialUpdate
     */
    hook?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobPartialUpdate
     */
    webhookSecret?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobPartialUpdate
     */
    securityContext?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobPartialUpdate
     */
    partOfWorkflowFor?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum JobPartialUpdateSpecialTypeEnum {
    NUMBER_2 = 2,
    NUMBER_3 = 3
}/**
* @export
* @enum {string}
*/
export enum JobPartialUpdateInputTypeEnum {
    Path = 'path',
    Dir = 'dir',
    Paths = 'paths',
    Dirs = 'dirs'
}

export function JobPartialUpdateFromJSON(json: any): JobPartialUpdate {
    return JobPartialUpdateFromJSONTyped(json, false);
}

export function JobPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subtasks': !exists(json, 'subtasks') ? undefined : ((json['subtasks'] as Array<any>).map(SubtaskReferenceFromJSON)),
        'schedules': !exists(json, 'schedules') ? undefined : ((json['schedules'] as Array<any>).map(ScheduleReferenceFromJSON)),
        'allowUsers': !exists(json, 'allow_users') ? undefined : ((json['allow_users'] as Array<any>).map(ElementsUserReferenceFromJSON)),
        'allowGroups': !exists(json, 'allow_groups') ? undefined : ((json['allow_groups'] as Array<any>).map(ElementsGroupReferenceFromJSON)),
        'variableDefinitions': !exists(json, 'variable_definitions') ? undefined : json['variable_definitions'],
        'mediaRoots': !exists(json, 'media_roots') ? undefined : json['media_roots'],
        'specialType': !exists(json, 'special_type') ? undefined : json['special_type'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'allowOthersToStart': !exists(json, 'allow_others_to_start') ? undefined : json['allow_others_to_start'],
        'allowClientToStart': !exists(json, 'allow_client_to_start') ? undefined : json['allow_client_to_start'],
        'showAsButton': !exists(json, 'show_as_button') ? undefined : json['show_as_button'],
        'inputType': !exists(json, 'input_type') ? undefined : json['input_type'],
        'addToNewMediaRoots': !exists(json, 'add_to_new_media_roots') ? undefined : json['add_to_new_media_roots'],
        'hook': !exists(json, 'hook') ? undefined : json['hook'],
        'webhookSecret': !exists(json, 'webhook_secret') ? undefined : json['webhook_secret'],
        'securityContext': !exists(json, 'security_context') ? undefined : json['security_context'],
        'partOfWorkflowFor': !exists(json, 'part_of_workflow_for') ? undefined : json['part_of_workflow_for'],
    };
}

export function JobPartialUpdateToJSON(value?: JobPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtasks': value.subtasks === undefined ? undefined : ((value.subtasks as Array<any>).map(SubtaskReferenceToJSON)),
        'schedules': value.schedules === undefined ? undefined : ((value.schedules as Array<any>).map(ScheduleReferenceToJSON)),
        'allow_users': value.allowUsers === undefined ? undefined : ((value.allowUsers as Array<any>).map(ElementsUserReferenceToJSON)),
        'allow_groups': value.allowGroups === undefined ? undefined : ((value.allowGroups as Array<any>).map(ElementsGroupReferenceToJSON)),
        'variable_definitions': value.variableDefinitions,
        'media_roots': value.mediaRoots,
        'special_type': value.specialType,
        'name': value.name,
        'description': value.description,
        'enabled': value.enabled,
        'allow_others_to_start': value.allowOthersToStart,
        'allow_client_to_start': value.allowClientToStart,
        'show_as_button': value.showAsButton,
        'input_type': value.inputType,
        'add_to_new_media_roots': value.addToNewMediaRoots,
        'hook': value.hook,
        'webhook_secret': value.webhookSecret,
        'security_context': value.securityContext,
        'part_of_workflow_for': value.partOfWorkflowFor,
    };
}


